export const JobLocation = {
  ONSITE: 'ONSITE',
  REMOTE: 'REMOTE',
} as const;
export type JobLocation = (typeof JobLocation)[keyof typeof JobLocation];

/** Discover-jobs compensation bracket filter (NGN). */
export const JobListingCompensationTier = {
  LOW: 'LOW',
  MID: 'MID',
  HIGH: 'HIGH',
} as const;
export type JobListingCompensationTier =
  (typeof JobListingCompensationTier)[keyof typeof JobListingCompensationTier];
